module.exports = __webpack_public_path__ + "img/black_queen.e57aff20.png";